/**
 * 首字母大写
 * @param str {string}
 * @returns {string}
 */
export const upperFirst = str => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * 首字母小写
 * @param str {string}
 * @returns {string}
 */
export const lowerFirst = str => str.charAt(0).toLowerCase() + str.slice(1);

/**
 * 字符串转pascal命名风格
 * @param str {string} 命名字符串
 * @param separator {string} 字符串单词分割字符
 * @returns {string}
 */
export const name2PascalCase = (str, separator = '-') => {
    const items = str.split(separator);
    return items.map(k => upperFirst(k)).join('');
};

/**
 * 字符串传驼峰命名风格
 * @param str {string} 命名字符串
 * @param separator {string} 字符串单词分割字符
 * @returns {string}
 */
export const name2CamelCase = (str, separator = '-') => {
    const items = str.split(separator);
    return items.map((k, i) => (i === 0 ? lowerFirst(k) : upperFirst(k))).join('');
};

/**
 * kebab2camelCase 中划线全名转pascal命名(首字母大写的驼峰命名)
 * @param str {string}
 * @returns {string}
 */
export const kebab2PascalCase = str => {
    return name2PascalCase(str, '-');
};

/**
 * 中划线命名转驼峰命名
 * @param str {string}
 * @returns {string}
 */
export const kebab2CamelCase = str => {
    return name2CamelCase(str, '-');
};

/**
 * 下划线命名转pascal命名风格(首字母大小的驼峰写法)
 * @param str {string}
 * @returns {string}
 */
export const snake2PascalCase = str => {
    return name2PascalCase(str, '_');
};

/**
 * 下划线命名转驼峰命名风格
 * @param str {string}
 * @returns {string}
 */
export const snake2camelCase = str => {
    return name2CamelCase(str, '_');
};

/**
 * 驼峰写法
 * @param str {string}
 * @param separator {string}
 * @returns {string}
 */
export const camel2sepCase = (str, separator = '-') => {
    return lowerFirst(str).replace(/[A-Z]/g, m => `${separator}${m}`).toLowerCase();
};

/**
 * 驼峰写法转中划线写法
 * @param str {string}
 * @returns {string}
 */
export const camel2kebabCase = str => camel2sepCase(str, '-');

/**
 * 驼峰写法转下划线写法
 * @param str {string}
 * @returns {string}
 */
export const camel2snakeCase = str => camel2sepCase(str, '_');
